import _ from 'lodash';
import moment from 'moment';
import update from 'react-addons-update';
import { getAvailabilityWindow } from '../util/bookingHelpers';

import {
    RECEIVED_ENTITIES,
    BOOKING_UPDATED,
    SET_UNAVAILABLE_TIMES,
} from '../constants';

import {
    BOOKING_STATUS_UNAPPROVED,
    BOOKING_STATUS_APPROVED,
    BOOKING_STATUS_CHECKED_OUT,
    BOOKING_STATUS_CHECKED_IN,
    BOOKING_STATUS_CANCELLED,
} from '../constants/booking';

const initialState = {
    plant: {},
    plantTypes: {},
    persons: {},
    locations: {},
    travelReasons: {},
    costCentres: {},
    bookings: {},
    unavailableTimes: {},
    currentAvailabilityWindows: {}
};

const momentifyAllBookings = (bookings) => {
    _.forEach(bookings, booking => {
        bookings = update(bookings, {
            [booking.staticUId]: {  $set: momentifyBookingDates(booking) },
        });
    });

    return bookings;
};

const receivedEntities = (state, action) => {
    return update(state, {
        plant: { $set: action.entities.plant },
        plantTypes: { $set: action.entities.plantTypes },
        persons: { $set: action.entities.persons },
        locations: { $set: action.entities.locations },
        travelReasons: { $set: action.entities.travelReasons },
        costCentres: { $set: action.entities.costCentres },
        bookings: { $set: momentifyAllBookings(action.entities.bookings) },
    });
};

const momentifyBookingDates = (booking) => {
    return update(booking, {
        startTime: { $set: booking.startTime ? moment(booking.startTime) : null },
        endTime:  { $set: booking.endTime ? moment(booking.endTime) : null },
        checkOutTime: { $set: booking.checkOutTime ? moment(booking.checkOutTime) : null },
        checkInTime: { $set: booking.checkInTime ? moment(booking.checkInTime) : null },
        cancelledOnTime: { $set: booking.cancelledOnTime ? moment(booking.cancelledOnTime) : null },
        approvedOnTime: { $set: booking.approvedOnTime ? moment(booking.approvedOnTime) : null },
        createdAtTime: { $set: booking.createdAtTime ? moment(booking.createdAtTime) : null },
    });
};

const momentifyUnavailableTimes = (unavailableTimes) => {
    const result = unavailableTimes.unavailableSlots.map(s => {
        return {
            startTime: moment(s.startTime),
            endTime: moment(s.endTime),
            reasons: s.reasons, // make sure that we preserve the reasons that we are unavailable
        };
    });

    return update(unavailableTimes, {
        unavailableSlots: { $set: result },
    });
};

const updateBooking = (state, booking) => {
    return update(state, {
        bookings: {
            [booking.staticUId]: { $set: momentifyBookingDates(booking) },
        }
    });
};

const setUnavailableTimes = (state, staticUId, unavailableTimes) => {
    const momentifiedUnavailableTimes = momentifyUnavailableTimes(unavailableTimes);
    const currentAvailabilityWindow = getAvailabilityWindow(state.bookings[staticUId], momentifiedUnavailableTimes);

    return update(state, {
        unavailableTimes: {
            [staticUId]: { $set: momentifiedUnavailableTimes },
        },
        currentAvailabilityWindows: {
            [staticUId]: { $set: currentAvailabilityWindow }
        }
    });
};

export default function entities(state = initialState, action) {
    switch (action.type) {
        case RECEIVED_ENTITIES:
            return receivedEntities(state, action);
        case BOOKING_UPDATED:
            return updateBooking(state, action.booking);
        case SET_UNAVAILABLE_TIMES:
            return setUnavailableTimes(state, action.staticUId, action.unavailableTimes);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./scripts/reducers/entities.js